/************************************** THIRD-PARTY MODULES ***************************************/
import {toJS} from 'mobx';

/**************************************** PROJECT MODULES *****************************************/
import {RecordInstance, LocalDate} from '@canimmunize/javelinscript';

/********************************************* EXPORT *********************************************/
/**
 *  Store for values from last state of RecordModel
 *
 *  Purpose: deciding when to fully update all RecordModel pages (update if any
 *  of the values in this store don't match the current record)
 *
 *  Reason: updating all pages on every minor change is extremely unperformant
 *  and causes confusing side effects
 */
export class LastRecordStateModel {
    /**
     * If any of these values don't match the current record settings value,
     * all pages should be recalculated and visit boxes re-rendered
     */
    birthdate: LocalDate = null;
    scheduleId: string = null;
    gender: number = null; // 0 = male; 1 = female

    /**
     * Store current record settings values, to later determine if they've
     * changed (and thus whether to replace & re-render all page data)
     */
    public updateLastRecordSettings = (record: RecordInstance) => {
        const localRecord = toJS(record);
        this.birthdate = localRecord.birthdate;
        this.scheduleId = localRecord.scheduleId;
        this.gender = localRecord.gender;
    };

    /**
     * Determine if all stored pages should be replaced or not (done if region,
     * birthdate, or gender has changed)
     */
    public hasRecordChanged = (record: RecordInstance) => {
        if (
            !record.birthdate.isEqual(this.birthdate) ||
            record.scheduleId !== this.scheduleId ||
            record.gender !== this.gender
        ) {
            return true;
        }
    };

    /**
     * Build store for values from "previous" RecordModel state
     * Stores non-reactive values
     */
    public static new = (record: RecordInstance): LastRecordStateModel => {
        return new LastRecordStateModel(record);
    };

    private constructor(record: RecordInstance) {
        this.updateLastRecordSettings(record);
    }
}
